import React from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MissionValuesSection from './components/MissionValuesSection';
import AchievementsSection from './components/AchievementsSection';
import WhyESBSection from './components/WhyESBSection';
import ProductPortfolioSection from './components/ProductPortfolioSection';
import GlobalPartnershipsSection from './components/GlobalPartnershipsSection';
import ContactSection from './components/ContactSection';

const Homepage = () => {
  return (
    <>
      <HeroSection />
      <div className="space-y-24 lg:space-y-32">
        <AboutSection />
        <ProductPortfolioSection />
        <MissionValuesSection />
        <AchievementsSection />
        <WhyESBSection />
        <GlobalPartnershipsSection />
        <ContactSection />
      </div>
    </>
  );
};

export default Homepage;